module.exports = __webpack_public_path__ + "static/img/img24.4cac18f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img24.png
// module id = jpE3
// module chunks = 1